import React, { useContext } from "react";
import useViewport from "@hooks/useViewport.js";
import { AuthContext } from "@context/AuthContext";
import Button from "@components/Ui/Button";
import "./style.scss";

const VoucherButtons = ({ value, setValue }) => {
    const { drawerState, openDrawer } = useContext(AuthContext);

    const { width } = useViewport();
    const isMobile = width <= 1024;

    const quantity = value || 0;
    const inputValue = quantity > 0 ? String(quantity) : "";

    const openCheckoutDrawer = () => {
        if (!isMobile && !drawerState.voucherCheckoutDrawer) {
            openDrawer("voucherCheckoutDrawer");
        }
    };

    const handleInputChange = (e) => {
        const val = e.target.value;
        if (val === "") {
            setValue(0);
            return;
        }

        if (/^\d+$/.test(val)) {
            const parsed = parseInt(val, 10);
            setValue(parsed);
            if (parsed > 0) openCheckoutDrawer();
        }
    };

    const handleIncrement = () => {
        setValue(quantity + 1);
        openCheckoutDrawer();
    };

    const handleDecrement = () => {
        const newVal = Math.max(quantity - 1, 0);
        setValue(newVal);
        // Don't open the drawer for an item that's just been removed.
        if (newVal > 0) openCheckoutDrawer();
    };

    return (
        <div className="voucher-search__buttons">
            <Button
                additionalClasses="voucher-search__button voucher-search__button--decrement"
                onClick={handleDecrement}
            >
                -
            </Button>
            <input
                type="text"
                aria-label="quantity input"
                className="number-input__text"
                placeholder="0"
                value={inputValue}
                onChange={handleInputChange}
            />
            <Button
                additionalClasses="voucher-search__button voucher-search__button--increment"
                onClick={handleIncrement}
            >
                +
            </Button>
        </div>
    );
};

export default VoucherButtons;
